import axios from 'axios';
import config from 'config/config';
import { AdminPerson } from 'types/intra';

class IntraService {
    host = config.API_BASE_URL;
    code = config.INTRA_API_SECRET;

    async getAdminPersons(): Promise<AdminPerson[]> {
        const result = await axios.get<AdminPerson[]>(`${this.host}/api/v1/admin/${this.code}`);
        return result.data;
    }

    async updateArrivedAndFoodPaid(
        id: string,
        arrived: boolean,
        food_paid: boolean,
        staff_food: boolean,
        staff_price: number
    ): Promise<void> {
        await axios.put(`${this.host}/api/v1/admin/${id}/${this.code}`, {
            arrived,
            food_paid,
            staff_food,
            staff_price
        });
    }

    async resetAdmin(): Promise<void> {
        await axios.post(`${this.host}/api/v1/admin/reset/${this.code}`);
    }
}

export default new IntraService();
